import React from 'react';
import ScheduleBlock from './ScheduleBlock';
import { BlockContainer } from './styled';
import TextHelper from '@/core/helpers/TextHelper';

interface IProps {
  courseModality?: string;
  schedule?: any;
  professors?: string[];
  module?: string;
}
const FirstBlock = (props: IProps) => {
  const { courseModality, schedule, professors, module } = props;
  let modalityString = '';

  switch (courseModality) {
    case 'P': {
      modalityString = 'Presencial';
      break;
    }
    case 'SP': {
      modalityString = 'Semipresencial';
      break;
    }
    case 'VT': {
      modalityString = 'Virtual 24/7';
      break;
    }
    case 'R': {
      modalityString = 'Virtual en vivo';
      break;
    }
    default: {
      modalityString = '--';
    }
  }

  return (
    <BlockContainer>
      <div className="row" data-testid="cmp-firstblock-mycourses">
        <div className="column">
          {/* DOCENTE */}
          <p>
            {!professors ? (
              <div>
                <span style={{ display: 'flex', padding: '0px' }}>
                  Docente: --
                </span>
              </div>
            ) : (
              <div>
                {professors?.length <= 1 ? (
                  <p style={{ display: 'flex' }}>
                    Docente:{' '}
                    <span>
                      {TextHelper.capitalize(
                        professors[0].replace(',', ', '),
                        false,
                        false
                      )}
                    </span>
                  </p>
                ) : (
                  <div style={{ display: 'flex' }}>
                    Docente:
                    <span>
                      <ul style={{ marginLeft: '21px' }}>
                        {professors?.map((teacher: any, i: number) => (
                          <li key={i}>
                            {TextHelper.capitalize(
                              teacher?.replace(',', ', '),
                              false,
                              false
                            )}
                          </li>
                        ))}
                      </ul>
                    </span>
                  </div>
                )}
              </div>
            )}
          </p>
          {/* DOCENTE */}
          <p>
            Modalidad de curso: <span>{modalityString}</span>
          </p>
          {module && (
            <p>
              Módulo: <span>{module}</span>
            </p>
          )}
        </div>
        <div className="column">
          <ScheduleBlock
            schedule={schedule}
            isVirtual={courseModality === 'VT'}
          />
        </div>
      </div>
    </BlockContainer>
  );
};

export default FirstBlock;
